export const ProfileStatus = {
  New: "New",
  Verified: "Verified",
  Active: "Active",
  Draft: "Draft"
};